export enum SysLanguage {
    Dutch = 1,
    French,
    English,
    German,
    Spanish,
    Italian,
    Arab,
    Bulgarian,
    Catalan,
    Chinese,
    Danish,
    Estonian,
    Finnish,
    Greek,
    Hungarian,
    Japanese,
    Croatian,
    Latvian,
    Lithuanian,
    Maltese,
    Mandarin,
    Norwegian,
    Polish,
    Portuguese,
    Romanian,
    Russian,
    Slovenian,
    Slovak,
    Czech,
    Turkish,
    South_American_Spanish,
    Swedish
}